import { NotFound } from "@components/widgets/ErrorPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/404")({
  component: NotFound,
});
